import { render, staticRenderFns } from "./OrderDisplay.vue?vue&type=template&id=69dcc7ab&scoped=true&"
import script from "./OrderDisplay.vue?vue&type=script&lang=js&"
export * from "./OrderDisplay.vue?vue&type=script&lang=js&"
import style0 from "./OrderDisplay.vue?vue&type=style&index=0&id=69dcc7ab&lang=scss&scoped=true&"
import style1 from "./OrderDisplay.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dcc7ab",
  null
  
)

export default component.exports